export type RecombeeDataType =
    | 'string'
    | 'int'
    | 'double'
    | 'timestamp'
    | 'boolean'
    | 'set'
    | 'image'
    | 'imageList';

export type AddGamePropertyRequest = Record<string, RecombeeDataType>;
export type AddUserPropertyRequest = Record<string, RecombeeDataType>;

export type AddGameRequest = {
    gameId: string;
    creatorUserId?: string;
    createdAt?: string;
    coinPrice?: number;
    diamondPrice?: number;
    gemName?: string;
    gemType?: string;
    craftIngredients?: number[];
    ipType?: string;
    characters?: string[];
    background?: string;
    gameLength?: number; // number of steps in the game
    genres?: string[];
    tags?: string[];
    isRemix?: boolean;
    description?: string;
};

export type AddUserRequest = {
    userId: string;
    createdAt?: string;
    followers?: number;
    diamondPortfolioValue?: number;
    diamondCreatorValue?: number;
    coinPortfolioValue?: number;
    coinCreatorValue?: number;
    diamondBalance?: number;
    coinBalance?: number;
    followingList?: string[];
    followersList?: string[];
};

export interface MergeUserRequest {
    targetUserId: string;
    sourceUserId: string;
    cascadeCreate?: boolean;
}

export interface Interaction {
    userId: string;
    gameId: string;
    recommId?: string;
    timestamp?: string;
}

export interface AddViewPortionRequest extends Interaction {
    portion: number;
    sessionId?: string;
}

export interface AddDetailViewRequest extends Interaction {
    duration: number;
    sessionId?: string;
}

export interface AddTradeRequest extends Interaction {
    price?: number;
    profit?: number;
}

export enum Rating {
    Like = 1,
    Unlike = -1,
    Neutral = 0,
}

export interface AddRatingRequest extends Interaction {
    rating: Rating;
}

export interface ListGameDetails {
    itemId: string;
}

export interface ListUserDetails {
    userId: string;
}

export interface ListGames {
    filter?: string;
    count?: number;
    offset?: number;
    returnProperties?: boolean;
    includedProperties?: string[];
}

export interface Recommendation {
    userId: string;
    count: number;
    returnProperties?: boolean;
    includedProperties?: string[];
    scenario?: string;
    filter?: string;
    booster?: string;
    logic?: string;
    minRelevance?: string;
}

export type RecommendGamesToUserRequest = Recommendation

export interface RecommendGamesToGameRequest extends Recommendation {
    gameId: string;
}

export type RecommendUsersToUserRequest = Recommendation

export interface RecommendUsersToGameRequest extends Recommendation {
    gameId: string;
}

export type NextGamesRequest = {
    recommId: string;
    count: number;
};

export type SearchGamesRequest = {
    userId: string;
    searchQuery: string;
    count: number;
};
